module.exports = __webpack_public_path__ + "static/img/15.066a905.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/eng/15.png
// module id = eerh
// module chunks = 0